export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";